import { render, staticRenderFns } from "./InactiveCategory.vue?vue&type=template&id=d66210ba&scoped=true&"
import script from "./InactiveCategory.vue?vue&type=script&lang=js&"
export * from "./InactiveCategory.vue?vue&type=script&lang=js&"
import style0 from "./InactiveCategory.vue?vue&type=style&index=0&id=d66210ba&prod&lang=scss&scoped=true&"
import style1 from "./InactiveCategory.vue?vue&type=style&index=1&id=d66210ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66210ba",
  null
  
)

export default component.exports